import * as React from "react";
import {connect} from "react-redux";
import {onDialogClose} from "components/Dialog/reducers/dialog";
import {DialogLayoutDispatchProps, DialogLayout} from "components/DialogLayout/DialogLayout";
import { Dispatch, Action } from "redux";
import { Omit } from "utils/omit";

export class DialogLayoutConnect {
    static to<TProps extends any>(component: React.ComponentType<TProps & DialogLayoutDispatchProps>) {
        const mapDispatchToProps = (dispatch: Dispatch<Action<any>>, props: TProps): DialogLayoutDispatchProps => {
            return {
                close: () => {
                    dispatch(onDialogClose());
                }
            };
        };
        return connect(null, mapDispatchToProps)(component as any) as React.ComponentType<TProps>;
    }
}

export default DialogLayoutConnect;